import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { RouteUrl } from "utils";
import LoginPage from "pages/auth/login/LoginPage";
import NotFoundPage from "./pages/page-not-found/NotFoundPage";
import PrivateRoute from "./components/PrivateRoute";
import PublicRoute from "./components/PublicRoute";
import ShopMenuPage from "./pages/shop-menu/ShopMenuPage";
import WelcomePage from "./pages/welcome/IndexPage";
import TermOfPrivacyPage from "./pages/term-of-privacy/TermOfPrivacyPage";
import TermOfServices from "pages/term-of-services/TermOfService";
import ViewShop from "pages/view-shop/ViewShop";
import ViewProduct from "pages/view-product/ViewProduct";
import Following from "pages/following/Following";
import NewsFeed from "pages/news-feed/NewsFeed";
import MarketPlaces from "pages/market-places/MarketPlaces";
import Chat from "pages/chat/Chat";
import { useEffect } from "react";
import SigUpPage from "pages/auth/sign-up/SignUpPage";
import ForgotPasswordPhonePage from "pages/auth/forgot-password-phone/ForgotPasswordPhonePage";
import ResetPasswordPage from "pages/auth/reset_password/ResetPasswordPage";
import ForgotPasswordEmailPage from "pages/auth/forgot-password-email/ForgotPasswordEmailPage";
import { initOneSignal } from "utils/oneSignalService";
import ChooseInterestCategory from "pages/user-interest/ChooseInterestCategory";
import Profile from "pages/profile/Profile";
import SettingAndSecurity from "pages/setting-and-account/SettingAndSecurity";
import BusinessSuite from "pages/business-suite/BusinessSuite";
import BlockAccounts from "pages/setting-and-account/BlockAccounts";
import BoringAccounts from "pages/setting-and-account/BoringAccounts";
import LoggedDevices from "pages/setting-and-account/LoggedDevices";
import RequestVerificationAccount from "pages/setting-and-account/RequestVerificationAccount";
import SoundLibraries from "pages/setting-and-account/SoundLibraries";
import ChangePassword from "pages/setting-and-account/ChangePassword";
import DeleteAccount from "pages/setting-and-account/DeleteAccount";
import DisactivateAccount from "pages/setting-and-account/DisactivateAccount";
import DeleteAccountPageStatus from "pages/page-status/DeleteAccountPageStatus";
import DisactivateAccountPageStatus from "pages/page-status/DisactivateAccountPageStatus";
import ChangePasswordPageStatus from "pages/page-status/ChangePasswordPageStatus";
import Interesting from "pages/setting-and-account/Interesting";
import SwitchAccount from "pages/setting-and-account/SwitchAccount";
import ProfileDetail from "pages/setting-and-account/profile-detail/ProfileDetail";
import RequestDeleteAccount from "pages/flipflop-support-center/RequestDeleteAccount";
import SendRequestFeedback from "pages/flipflop-support-center/SendRequestFeedback";
import ReceiveRequestFeedback from "pages/flipflop-support-center/ReceiveRequestFeedback";
import { SocketProvider } from "services/SocketContext";
import ProfileView from "pages/setting-and-account/ProfileView";
import DashboardPage from "pages/dashboard/DashboardPage";
import Language from "pages/setting-and-account/Language";
// import ProductService from "pages/business-suite/ProductService";
// import Staff from "pages/business-suite/Staff";
import Campaigns from "pages/account-detail/Campaigns";
import Leads from "pages/account-detail/Leads";
import Opportunities from "pages/account-detail/Opportunities";
import Jobs from "pages/account-detail/Jobs";
import Events from "pages/account-detail/Events";
import Dashboard from "pages/business-suite/Dashboard";
import TodoPage from "pages/todo/todoPage";
import Projects from "pages/account-detail/Projects";
import MusicLibraries from "pages/account-detail/MusicLibraries";
import FacebookLayout from "pages/facebook-layout/FacebookLayout";
import StoriesViewer from "pages/facebook-stories-ui/FacebookStoriesUI";
import AccountDashbaord from "pages/account-detail/AccountDashboard";
import Tools from "pages/business-suite/Tools";
// import AccountTools from "pages/account-detail/tools/AccountTools";
import UploadPage from "pages/upload/UploadPage";
import PhotoPage from "modals/photo/PhotoPage";
import ViewPostPage from "pages/view-post/ViewPostPage";
import Testing from "pages/account-detail/Testing";
import useSocketStore from "store/useSocketStore";
// import AccountTools from "pages/account-detail/tools/AccountTools";
import AccountTools from "pages/account-detail/AccoutTools";
import ViewStoryPage from "pages/view-story/ViewStoryPage";
import SuggestionSearch from "components/app/search-bar/SuggestionSearch";
import LiveStream from "pages/live-stream/LiveStream";
import VideoJSLiveView from "pages/video-js-live-view/VideoJsLiveView";
// import TimeSheet from "pages/business-suite/TimeSheet";
import LiveStudioPage from "pages/live-studio/LiveStudioPage";
import Layout from "layout/layout";
// import Payroll from "pages/business-suite/payroll";
import LoginPage2 from "pages/auth/login/LoginPage2";
import Leave from "pages/business-suite/leave/Leave";
import LiveStreamFlv from "pages/live-studio/LiveStudioFlvPage";
import Request from "pages/business-suite/request/Request";
import TimeSheet from "pages/business-suite/timesheet/TimeSheet";
import ProductService from "pages/business-suite/productservicse/ProductService";
import Staff from "pages/business-suite/staff/Staff";
import Staff2 from "pages/business-suite/Staff";
// import Payroll from "pages/business-suite/payroll";
import EssAttendance from "pages/business-suite/EssAttendance";
import Calendar from "pages/business-suite/calendar/Calendar";
import Payroll from "pages/business-suite/payroll/Payroll";
// import Payroll from "pages/business-suite/payroll/Payroll";

// import Hero from "pages/business-suite/Payroll";
// import Payroll from "pages/business-suite/Payroll";

function App() {
  useEffect(() => {
    initOneSignal();
    useSocketStore.getState().initializeSocket();
  }, []);

  return (
    <Router>
      <SocketProvider>
        <Routes>
          <Route element={<PublicRoute />}>
            <Route path={RouteUrl.forgotPasswordPhone} element={<ForgotPasswordPhonePage />} />
            <Route path={RouteUrl.forgotPasswordEmail} element={<ForgotPasswordEmailPage />} />
            <Route path={RouteUrl.signUp} element={<SigUpPage />} />
            <Route path={RouteUrl.login} element={<LoginPage2 />} />
            {/* <Route path={RouteUrl.login} element={<LoginPage />} /> */}
            <Route path={RouteUrl.resetPassword} element={<ResetPasswordPage />} />
          </Route>

          {/* Private routes */}
          <Route element={<PrivateRoute />}>
            <Route element={<Layout />}>
              {/* Account Setting */}
              <Route path={RouteUrl.ProfileDetail} element={<ProfileDetail />} />
              <Route path={RouteUrl.setting} element={<SettingAndSecurity />} />
              <Route path={RouteUrl.viewProfile} element={<ProfileView />} />
              <Route path={RouteUrl.blockAccount} element={<BlockAccounts />} />
              <Route path={RouteUrl.boringAccount} element={<BoringAccounts />} />
              <Route path={RouteUrl.interesting} element={<Interesting />} />
              <Route path={RouteUrl.changePassword} element={<ChangePassword />} />
              <Route path={RouteUrl.deleteAccount} element={<DeleteAccount />} />
              <Route path={RouteUrl.desActivateAccount} element={<DisactivateAccount />} />
              <Route path={RouteUrl.switchAccount} element={<SwitchAccount />} />
              <Route path={RouteUrl.loggedDevices} element={<LoggedDevices />} />
              <Route path={RouteUrl.language} element={<Language />} />
              <Route path={RouteUrl.soundLibraries} element={<SoundLibraries />} />

              <Route path={RouteUrl.requestVerificationAccount} element={<RequestVerificationAccount />} />
            </Route>

            {/* BusinessSuite */}
            <Route element={<Layout headerType="businessSuite" isHeader2={true} />}>
              <Route path={RouteUrl.businessSuite} element={<BusinessSuite />} />
              <Route path={RouteUrl.dashboard} element={<Dashboard />} />
              <Route path={RouteUrl.productService} element={<ProductService />} />
              <Route path={RouteUrl.timeSheet} element={<TimeSheet />} />
              <Route path="testing" element={<Staff2 />} />
              <Route path={RouteUrl.staff} element={<Staff />} />
              <Route path={RouteUrl.tools} element={<Tools />} />
              <Route path={RouteUrl.payroll} element={<Payroll />} />
              <Route path={RouteUrl.leave} element={<Leave />} />
              <Route path={RouteUrl.request} element={<Request />} />
              <Route path={RouteUrl.calendar} element={<Calendar />} />
            </Route>

            {/* Account Detail */}
            <Route element={<Layout headerType="profileSuite" isHeader2={true} />}>
              <Route path={RouteUrl.accountDashboard} element={<AccountDashbaord />} />
              <Route path={RouteUrl.musicLibraries} element={<MusicLibraries />} />
              <Route path={RouteUrl.campaigns} element={<Campaigns />} />
              <Route path={RouteUrl.leads} element={<Leads />} />
              <Route path={RouteUrl.opportunities} element={<Opportunities />} />
              <Route path={RouteUrl.jobs} element={<Jobs />} />
              <Route path={RouteUrl.events} element={<Events />} />
              <Route path={RouteUrl.projects} element={<Projects />} />
              <Route path={RouteUrl.tools} element={<Tools />} />
              <Route path={RouteUrl.toolsAccount} element={<AccountTools />} />
            </Route>

            <Route path={RouteUrl.testing} element={<Testing />} />
            {/* <Route path={RouteUrl.accuonttools} element={<AccountTools />} /> */}

            <Route path={RouteUrl.shopClockTime} element={<EssAttendance />} />
            <Route path={RouteUrl.liveStudio} element={<LiveStreamFlv />} />
          </Route>
          {/* End Private routes */}

          {/*  Inteers */}
          <Route path={RouteUrl.interestingCategory} element={<ChooseInterestCategory />} />

          {/* Catch-all route for 404 */}
          <Route path="*" element={<NotFoundPage />} />

          {/* Public routes with layout */}
          <Route element={<Layout />}>
            <Route path={RouteUrl.welcome} element={<WelcomePage />} />
            <Route path={RouteUrl.profile} element={<Profile />} />
            <Route path={RouteUrl.following} element={<Following tag="following" />} />

            {/* search bar */}
            <Route path={RouteUrl.SuggestionSearch} element={<SuggestionSearch />} />

            {/* === New Feed with modal === */}
            <Route path={RouteUrl.newsFeed} element={<NewsFeed />} />
            <Route path={RouteUrl.marketPlaces} element={<MarketPlaces />} />

            <Route path={RouteUrl.forme} element={<Following tag="search" />} />
          </Route>
          {/* End Public routes with layout */}

          <Route element={<Layout isHideLayout={true} />}>
            <Route path={RouteUrl.profilePostContentsPageView} element={<ViewPostPage />} />
            <Route path={RouteUrl.viewStories} element={<ViewStoryPage />} />
          </Route>

          {/* Public routes without layout */}
          <Route path={RouteUrl.requestDeleteAccount} element={<RequestDeleteAccount />} />
          <Route path={RouteUrl.sendRequestFeedback} element={<SendRequestFeedback />} />
          <Route path={RouteUrl.receiveRequestFeedback} element={<ReceiveRequestFeedback />} />
          <Route path={RouteUrl.deletePageStatus} element={<DeleteAccountPageStatus />} />
          <Route path={RouteUrl.disactivatePageStatus} element={<DisactivateAccountPageStatus />} />
          <Route path={RouteUrl.changePasswordPageStatus} element={<ChangePasswordPageStatus />} />

          <Route path={RouteUrl.shopMenu} element={<ShopMenuPage />} />
          <Route path={RouteUrl.termOfPrivacy} element={<TermOfPrivacyPage />} />
          <Route path={RouteUrl.termOfServices} element={<TermOfServices />} />
          <Route path={RouteUrl.viewShop} element={<ViewShop />} />
          <Route path={RouteUrl.viewProduct} element={<ViewProduct />} />

          {/* <Route path={RouteUrl.forme} element={<ForMe />} /> */}

          {/* <Route path={RouteUrl.viewStories} element={<NewsFeed />} /> */}

          <Route path="/photo/:id" element={<PhotoPage />} />

          {/* === ================= === */}

          <Route path={RouteUrl.chat} element={<Chat />} />

          {/* JK Testing route */}
          <Route path="/jackie-test" element={<DashboardPage />} />
          <Route path="/todo" element={<TodoPage />} />
          <Route path="/facebook" element={<FacebookLayout />} />
          <Route path="/facebook-stories" element={<StoriesViewer />} />
          <Route path="/upload" element={<UploadPage />} />
          <Route path="/live" element={<LiveStream />} />
          <Route path="/live-js" element={<VideoJSLiveView />} />
        </Routes>
      </SocketProvider>
    </Router>
  );
}

export default App;
